
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="2.9 2.9 15 15">
  <path
    d="M6.52555 4.03692C9.96717 1.96899 14.4336 3.08258 16.5015 6.5242C18.5694 9.96582 17.4558 14.4322 14.0142 16.5001C10.5726 18.5681 6.10621 17.4545 4.03827 14.0129C3.39484 12.942 3.04558 11.7468 3.00327 10.527L2.99909 10.2216L4.53905 10.2329C4.53143 11.2767 4.8082 12.3042 5.35831 13.2197C6.98819 15.9323 10.5085 16.81 13.221 15.1801C15.9336 13.5502 16.8113 10.0299 15.1814 7.31736C13.5895 4.66786 10.194 3.76889 7.50924 5.24731L7.31871 5.35696L6.52555 4.03692Z"
    fill="currentColor"
  ></path>
  <circle cx="9.99988" cy="9.99805" r="4" fill="currentColor"></circle>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Setp',
    }) as DefineComponent
    </script>
    